import { TimesheetMinimalPeriodsSource } from 'app/constants/configuration/timesheetMinimalPeriodsSource'

export const getTimesheetMinimalPeriodsSourceName = (
  timesheetMinimalPeriodsSource: TimesheetMinimalPeriodsSource,
  translate: (string) => string,
): string => {
  const text: string =
    TimesheetMinimalPeriodsSource[timesheetMinimalPeriodsSource]
  return translate(`timesheetMinimalPeriodsSource.${text}`)
}
